import React from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FilterBox from "../../../components/common/FilterBox";
import { FilterWrapper } from "./style";
const Filters = ({ handleOpenModal, filters, setFilters }) => {
  const filterForm = [
    {
      name: "societyNameFilter",
      type: "text",
      placeholder: "Search by Organization Name",
      value: filters.societyNameFilter,
    },
  ];
  return (
    <div>
      <Box
        sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3, flexWrap: "wrap", gap: 2 }}
      >
        <FilterWrapper>
          <FilterBox
            filterForm={filterForm}
            onFilterChange={(e, index) => {
              const { value } = e.target;
              setFilters((prev) => ({
                ...prev,
                [filterForm[index].name]: value,
              }));
            }}
            onFilterSubmit={(e) => e.preventDefault()}
            className="transactionfilter"
            buttonValue=""
          />
        </FilterWrapper>

        {/* <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={handleOpenModal}
          size="small"
          sx={{
            height: 40,
            backgroundColor: "#ED141F",
            "&:hover": {
              backgroundColor: "#ED141F",
            },
          }}
        >
          Add New Society
        </Button> */}
      </Box>
    </div>
  );
};

export default Filters;
